/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


 $(document).on('click', '#add_gift', function(e){
   
   jQuery.getJSON('/cart.js', function(cart) {
     // now have access to Shopify cart object
//      alert('There are now ' + cart.item_count + ' items in the cart.');
     var add_gift = true;
     for (x in cart.items) {
       console.log(cart.items[x].product_type);
       if(cart.items[x].product_type == 'Gift Wrap'){
        add_gift = false;
       }
     }
       console.log(add_gift);
     
     if ($('#additional_gift').is(':checked') && add_gift) {
e.preventDefault();
       
     Shopify.queue = [];
      $(this).attr("disabled","disabled");

     var rawItems = $('.all-products');
     //var cartItem = $('#the_select')
     //rawItems.push(cartItem)

     $(rawItems).each(function(i) {
       
       Shopify.queue.push({
         variantId: $(this).find(".products_varaint").val(),
         quantity: $(this).find(".prodcut_quantity").val(),
         properties : $(this).find('#personal_message').val()
       });
     });


     Shopify.addItem = function(id, qty, properties, callback) {
       
       var params = {
         quantity: qty,
         id: id,
         properties:{
           'personal message': properties
         }
       }
     
       $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         dataType: 'json',
         data: params,
         properties:{
           'personal message': properties
         },
         success: function(){
           if(typeof callback === 'function'){
             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
               bubbles: true  //this code is for prestige theme, is to refresh the cart
             }));
             $('.ptwAddToCart').trigger("click");
           }
         },
         error: function(){}
       });
     }

     Shopify.moveAlong = function() {
       // If we still have requests in the queue, let's process the next one.
       if (Shopify.queue.length) {
         var request = Shopify.queue.shift();
         Shopify.addItem(request.variantId, request.quantity,  request.properties, Shopify.moveAlong);
       }
       // If the queue is empty, we will redirect to the cart page.
       else {
//          document.location.href = '/cart';
         
       }
     };
     Shopify.moveAlong()
     //e.preventDefault();
     }else{
     $('.ptwAddToCart').trigger("click");
     }
     
   });
 
     
   });